import {get,post} from '@/http/interceptors.js'
import axios from '@/http/interceptors.js'
const CancelToken = axios.CancelToken;
let cancel
let cancelGetList

function getcookie(objname) {//获取指定名称的cookie的值
  var arrstr = document.cookie.split("; ");
  for (var i = 0; i < arrstr.length; i++) {
    var temp = arrstr[i].split("=");
    if (temp[0] == objname) return unescape(temp[1]);
  }
}
let token = null
// 登录
export const login = async (data) => {
  const res = await post('/employee/loginSubmit', data);
  return res;
}

// 首页
export const getHomeData= ()=>{
  token=getcookie('kmsToken')
  const res =  get(`/index/index?token=${token}`);
  return res;
}

// 查询所有制度类型
export const queryAllType= ()=>{
  token=getcookie('kmsToken')
  const res =  get(`/regType/queryAllType?token=${token}`);
  return res;
}

// 制度列表预加载
export const listLoad= ()=>{
  token=getcookie('kmsToken')
  const res =  get(`/regulations/listLoad?token=${token}`);
  return res;
}
// 获取所有执行负责人
export const queryAllManagerUser= ()=>{
  token=getcookie('kmsToken')
  const res =  get(`/regulations/queryAllManagerUser?token=${token}`);
  return res;
}


// 获取制度列表
export const typeRadio= (data)=>{
  token=getcookie('kmsToken')
  const res =  post(`/regulations/typeRadio?token=${token}`,data);
  return res;
}

// 制度列表目录
export const getCatalog= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/regulations/Directory?token=${token}`,data);
  return res;
}
// 根据制度id查询浏览人员
export const getRegulationsCount= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/regulations/regulationsCount?token=${token}`,data);
  return res;
}
// 黑库-黑名单列表 
export const queryBlackList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/regulations/queryBlackList?token=${token}`,data);
  return res;
}
// 服务-培训展示-获取课程回顾列表
export const getCourseReview= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/courseReview/list?token=${token}`,data);
  return res;
}

// 服务-培训展示-获取课程回顾详情
export const getCourseReviewDetail= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/courseReview/detail?token=${token}`,data);
  return res;
}
// 服务-培训展示-通知记录列表
export const getNoticeList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/notice/list?token=${token}`,data);
  return res;
}
// 服务-培训展示-培训项目
export const getTrainProject= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/trainingPrograms/list?token=${token}`,data);
  return res;
}
// 服务-培训展示-培训项目
export const getTrainProjectDetail= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/trainingPrograms/queryById?token=${token}`,data);
  return res;
}
// 服务-培训展示-培训项目-参训学员
export const getTrainStudent= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/studentsSummarize/list?token=${token}`,data);
  return res;
}
// 服务-行业发展报告-列表
export const getReportList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/industrialReport/list?token=${token}`,data);
  return res;
}
// 服务-行业发展报告-详情
export const getReportDetail= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/industrialReport/queryById?token=${token}`,data);
  return res;
}
// 服务-团队-列表
export const getTeamList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/team/list?token=${token}`,data);
  return res;
}
// 服务-团队-详情
export const getTeamDetail= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/team/queryById?token=${token}`,data);
  return res;
}
// 人事任命-人事任命列表
export const getAppointmentLetter= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/appointmentLetter/list?token=${token}`,data);
  return res;
}

// 人事任命-人事任命详情
export const getAppointmentLetterDetail= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/appointmentLetter/queryById?token=${token}`,data);
  return res;
}
// 服务-办公室分布图
export const getOfficeMap= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/officeMap/queryOffice?token=${token}`,data);
  return res;
}
// 优秀学师-匠才列表
export const getTalentList= (data)=>{
  token=getcookie('kmsToken')
  const res =  post(`/talentinfo/queryAll?token=${token}`,data);
  return res;
}
// 优秀学师-讲师列表
export const getTeacherList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/lectureMien/list?token=${token}`,data);
  return res;
}
// 优秀学师-匠才列表-未录入人员
export const getUnrecordList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/talentinfo/queryAllUser?token=${token}`,data);
  return res;
}
// 黑库-人才列表
export const getExPersonList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/talents/list?token=${token}`,data);
  return res;
}
// 岗位类型列表
export const getPostTypeList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/comm/queryData?token=${token}`,data);
  return res;
}
// 获取服务基地
export const getServerBase= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/comm/queryByStreetCode?token=${token}`,data);
  return res;
}
// 获取当前用户信息
export const getCurrentUser= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/comm/queryCurrentUser?token=${token}`,data);
  return res;
}
// 获取服务中心
export const getCenterList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/org/queryOrgCenter?token=${token}`,data);
  return res;
}
// 根据服务中心id获取部门
export const getDepartment= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/org/queryJurisdictionOrgList?token=${token}`,data);
  return res;
}
// 根据服务基地id获取街道信息
export const getAreaStreet= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/comm/getAreaStreet?token=${token}`,data);
  return res;
}
// 服务-招聘列表
export const getRecruitmentList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/recruitment/list?token=${token}`,data);
  return res;
}
// 获取学习记录列表
export const getStudyRecord= (data)=>{
  token=getcookie('kmsToken')
  const res =  post(`/videoViewingHours/queryAll?token=${token}`,data);
  return res;
}
// 直播-获取最近的一条直播记录
export const getLive= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/live/queryNewestLive?token=${token}`,data);
  return res;
}

// 视频列表
export const getVideoList = (data) => {
  token = getcookie('kmsToken')
  const res = post(`/video/list?token=${token}`, data, { cancelToken: new CancelToken(c => cancelGetList = c) });
  return res;
}
// 根据typeId查询视频类型
export const getVideoType= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/videoType/queryType?token=${token}`,data);
  return res;
}
// 查询子类型
export const getVideoSubType= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/videoType/querySubType?token=${token}`,data);
  return res;
}
// 获取视频播放路径
export const getVideoUrl= async (data)=>{
  token=getcookie('kmsToken')
  data.cancelToken=new CancelToken(c=>cancel=c)
  const res = await get(`/video/getUrl?token=${token}`,data);
  return res;
}
// 查询视频详情
export const getVideoDetail= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/video/queryById?token=${token}`,data);
  return res;
}
// 相关资料
export const getRelateData= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/curriculum/list?token=${token}`,data);
  return res;
}
// 课程课件
export const getPptList= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/ppt/list?token=${token}`,data);
  return res;
}

export const addPpt= (data)=>{
  token=getcookie('kmsToken')
  const res =  post(`/ppt/add?token=${token}`,data);
  return res;
}

export const uploadFile= (data)=>{
  token=getcookie('kmsToken')
  const res =  post(`/file/uploadFile?token=${token}`,data);
  return res;
}

// 视频点击次数增加
export const addVideoHits= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/video/addHits?token=${token}`,data);
  return res;
}
// 新增或更新视频记录
export const addOrUpdateVideoRecord= (data)=>{
  token=getcookie('kmsToken')
  const res =  post(`/videoViewingHours/addOrUpdate?token=${token}`,data);
  return res;
}

// 新增制度浏览次数
export const addReadCount= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/regulations/insertRegulationsRecord?token=${token}`,data);
  return res;
}

// 新增视频点赞
export const addVideoLike= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/recordLike/insertRecordLike?token=${token}`,data);
  return res;
}

// 删除视频点赞
export const delVideoLike= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/recordLike/delRecordLike?token=${token}`,data);
  return res;
}
// 查询点赞
export const queryRecordLike= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/recordLike/queryRecordLike?token=${token}`,data);
  return res;
}
// 登录1
export const login1= (data)=>{
  token=getcookie('kmsToken')
  const res =  post(`/employee/fromPM`,data);
  return res;
}

export const queryCurrentUser= (data)=>{
  token=getcookie('kmsToken')
  const res =  get(`/comm/queryCurrentUser?token=${token}`,data);
  return res;
}





export const cancleAxios = (type) => {
  console.log(type)
  switch (type) {
    case 1:
      cancel && cancel()
      break
    case 2:
      cancelGetList && cancelGetList()
      break
  }

}

//获取行业专家列表
export const expertList= (data)=>{
  token=getcookie('kmsToken')
  const res =  axios.post(`/industryExperts/list?token=${token}`,data);
  return res;
}
//获取行业专家类型
export const ConfigList= (data)=>{
  token=getcookie('kmsToken')
  const res =  axios.get(`/industryExperts/ConfigList?token=${token}`,data);
  return res;
}

// 数字化月报-当前月报概览
export const getDigitalAssessmentCurrent = (data) => {
  token = getcookie('kmsToken')
  const res = get(`/digitalAssessment/current?token=${token}`, data);
  return res;
}

// 数字化月报-月报详情
export const getDigitalAssessmentMonthDetail = (data) => {
  token = getcookie('kmsToken')
  const res = get(`/digitalAssessment/monthDetail?token=${token}`, data);
  return res;
}

// 数字化月报-提交/修改月报
export const submitDigitalAssessment = (data) => {
  token = getcookie('kmsToken')
  const res = axios.post(`/digitalAssessment/submit?token=${token}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
}

// 数字化月报-季度评分详情
export const getDigitalAssessmentQuarterDetail = (data) => {
  token = getcookie('kmsToken')
  const res = get(`/digitalAssessment/quarterDetail?token=${token}`, data);
  return res;
}

// 数字化月报-历史记录
export const getDigitalAssessmentHistory = (data) => {
  token = getcookie('kmsToken')
  const res = post(`/digitalAssessment/monthHistory?token=${token}`, data);
  return res;
}

// 数字化月报-互学广场列表
export const getDigitalAssessmentSquareList = (data) => {
  const res = axios.post('/digitalAssessment/square/list', data, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
  return res;
}

// 数字化月报-互学广场详情
export const getDigitalAssessmentSquareDetail = (data) => {
  const res = axios.get('/digitalAssessment/square/detail', { params: data });
  return res;
}

// 数字化月报-互学广场点赞
export const likeDigitalAssessmentSquare = (data) => {
  const res = axios.post('/digitalAssessment/square/like', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
}

// 数字化月报-互学广场取消点赞
export const unlikeDigitalAssessmentSquare = (data) => {
  const res = axios.post('/digitalAssessment/square/unlike', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
}
